import ResponseRequired from './ResponseRequired';
import MinTextLength from './minTextLength';
import MaxTextLength from './maxTextLength';
import GreaterThanValue from './gtValue';
import GreaterThanEqualValue from './gteValue';
import LessThanValue from './ltValue';
import LessThanEqualValue from './lteValue';
import GreaterThanField from './gtField';
import GreaterThanEqualField from './gteField';
import LessThanField from './ltField';
import LessThanEqualField from './lteField';
import NumericValue from './numericValue';
import EqualsValue from './equalsValue';
import EqualsField from './equalsField';
import ContainsValueCaseInsensitive from './containsValueCaseInsensitive';
import ContainsValueCaseSensitive from './containsValueCaseSensitive';
import DoesNotContainValueCaseInsensitive from "./doesNotContainValueCaseInsensitive";
import DoesNotContainValueCaseSensitive from "./doesNotContainValueCaseSensitive";

import ValidEmailAddress from "./validEmailAddress";
import ValidPhoneNumber from './validPhoneNumber';

import EqualsDate from './equalsDate';
import EqualsDateField from './equalsDateField';
import AfterDateIn from './afterDateIn';
import AfterDateEx from './afterDateEx';
import BeforeDateIn from './beforeDateIn';
import BeforeDateEx from './beforeDateEx';
import AfterDateFieldIn from './afterDateFieldIn';
import AfterDateFieldEx from './afterDateFieldEx';
import BeforeDateFieldIn from './beforeDateFieldIn';
import BeforeDateFieldEx from './beforeDateFieldEx';
import EqualsDateTime from './equalsDateTime';
import EqualsDateTimeField from './equalsDateTimeField';
import AfterDateTimeIn from './afterDateTimeIn';
import AfterDateTimeEx from './afterDateTimeEx';
import BeforeDateTimeIn from './beforeDateTimeIn';
import BeforeDateTimeEx from './beforeDateTimeEx';
import AfterDateTimeFieldIn from './afterDateTimeFieldIn';
import AfterDateTimeFieldEx from './afterDateTimeFieldEx';
import BeforeDateTimeFieldIn from './beforeDateTimeFieldIn';
import BeforeDateTimeFieldEx from './beforeDateTimeFieldEx';
import EqualsTime from './equalsTime';
import EqualsTimeField from './equalsTimeField';
import AfterTimeIn from './afterTimeIn';
import AfterTimeEx from './afterTimeEx';
import BeforeTimeIn from './beforeTimeIn';
import BeforeTimeEx from './beforeTimeEx';
import AfterTimeFieldIn from './afterTimeFieldIn';
import AfterTimeFieldEx from './afterTimeFieldEx';
import BeforeTimeFieldIn from './beforeTimeFieldIn';
import BeforeTimeFieldEx from './beforeTimeFieldEx';

const validationTypeMap = {
  gtValue: GreaterThanValue,
  gteValue: GreaterThanEqualValue,
  ltValue: LessThanValue,
  lteValue: LessThanEqualValue,
  gtField: GreaterThanField,
  gteField: GreaterThanEqualField,
  ltField: LessThanField,
  lteField: LessThanEqualField,
  minTextLength: MinTextLength,
  maxTextLength: MaxTextLength,
  responseRequired: ResponseRequired,
  numericValue: NumericValue,
  equalsValue: EqualsValue,
  equalsField: EqualsField,
  containsValueCaseInsensitive: ContainsValueCaseInsensitive,
  containsValueCaseSensitive: ContainsValueCaseSensitive,
  doesNotContainValueCaseInsensitive: DoesNotContainValueCaseInsensitive,
  doesNotContainValueCaseSensitive: DoesNotContainValueCaseSensitive,
  validEmailAddress: ValidEmailAddress,
  validPhoneNumber: ValidPhoneNumber,
  equalsDate: EqualsDate,
  afterDateIn: AfterDateIn,
  afterDateEx: AfterDateEx,
  beforeDateIn: BeforeDateIn,
  beforeDateEx: BeforeDateEx,
  afterDateFieldIn: AfterDateFieldIn,
  afterDateFieldEx: AfterDateFieldEx,
  beforeDateFieldIn: BeforeDateFieldIn,
  beforeDateFieldEx: BeforeDateFieldEx,
  equalsDateField: EqualsDateField,
  equalsDateTime: EqualsDateTime,
  afterDateTimeIn: AfterDateTimeIn,
  afterDateTimeEx: AfterDateTimeEx,
  beforeDateTimeIn: BeforeDateTimeIn,
  beforeDateTimeEx: BeforeDateTimeEx,
  afterDateTimeFieldIn: AfterDateTimeFieldIn,
  afterDateTimeFieldEx: AfterDateTimeFieldEx,
  beforeDateTimeFieldIn: BeforeDateTimeFieldIn,
  beforeDateTimeFieldEx: BeforeDateTimeFieldEx,
  equalsTimeField: EqualsDateTimeField,
  equalsTime: EqualsTime,
  afterTimeIn: AfterTimeIn,
  afterTimeEx: AfterTimeEx,
  beforeTimeIn: BeforeTimeIn,
  beforeTimeEx: BeforeTimeEx,
  afterTimeFieldIn: AfterTimeFieldIn,
  afterTimeFieldEx: AfterTimeFieldEx,
  beforeTimeFieldIn: BeforeTimeFieldIn,
  beforeTimeFieldEx: BeforeTimeFieldEx,
};

export default validationTypeMap;
